module.exports = __webpack_public_path__ + "media/gh-syuukyaku-top.a61d9bdd.mp4";